import {FanduelOptimizedLineupsView} from './fanduel-optimized-lineups-view';
import {DraftkingsOptimizedLineupsView} from './draftkings-optimized-lineups-view';
import {YahooOptimizedLineupsView} from './yahoo-optimized-lineups-view';
import {AbstractOptimizedLineupsView} from './optimized-lineups-view';
import OptimizedLineupsViewNotFoundError from './optimized-lineups-view-not-found-error';
import CharsConverter from 'services/chars-converter/chars-converter';

const viewMap = {
    draftkings: DraftkingsOptimizedLineupsView,
    fanduel: FanduelOptimizedLineupsView,
    yahoo: YahooOptimizedLineupsView,
};

const OptimizedLineupsViewFactory = {
    getView(sportConfig): AbstractOptimizedLineupsView {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return new viewMap[site](new CharsConverter());
        } catch (e) {
            if (e instanceof TypeError) {
                throw new OptimizedLineupsViewNotFoundError('Optimized Lineups View is undefined');
            }
            throw e;
        }
    },
};

export default OptimizedLineupsViewFactory;
